module.exports = __webpack_public_path__ + "media/images/flags/PN-2db015a573a3f59cf14424a20f2c38cb.svg";